module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'kjpm8dft',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
